export default __webpack_public_path__ + "static/media/avatar.c361a650.svg";